import {
  Flame, Shield, Hospital, Landmark, HeartPulse, School, Pill, Fuel, Utensils, Hotel
} from 'lucide-react';
// Die Pfaddaten der Icons werden für die Kartenmarker (L.divIcon, reines HTML) gebraucht
import { __iconNode as flameNode } from 'lucide-react/dist/esm/icons/flame';
import { __iconNode as shieldNode } from 'lucide-react/dist/esm/icons/shield';
import { __iconNode as hospitalNode } from 'lucide-react/dist/esm/icons/hospital';
import { __iconNode as landmarkNode } from 'lucide-react/dist/esm/icons/landmark';
import { __iconNode as heartPulseNode } from 'lucide-react/dist/esm/icons/heart-pulse';
import { __iconNode as schoolNode } from 'lucide-react/dist/esm/icons/school';
import { __iconNode as pillNode } from 'lucide-react/dist/esm/icons/pill';
import { __iconNode as fuelNode } from 'lucide-react/dist/esm/icons/fuel';
import { __iconNode as utensilsNode } from 'lucide-react/dist/esm/icons/utensils';
import { __iconNode as hotelNode } from 'lucide-react/dist/esm/icons/hotel';

// POI-Kategorien; die Schlüssel vergibt das Backend (POI_RULES in server.py)
export const POI_CATEGORIES = [
  { key: 'feuerwehr', label: 'Feuerwehr', color: '#dc2626', Icon: Flame, iconNode: flameNode },
  { key: 'polizei', label: 'Polizei', color: '#1d4ed8', Icon: Shield, iconNode: shieldNode },
  { key: 'krankenhaus', label: 'Krankenhaus / Rettungswache', color: '#be123c', Icon: Hospital, iconNode: hospitalNode },
  { key: 'rathaus', label: 'Rathaus', color: '#7c3aed', Icon: Landmark, iconNode: landmarkNode },
  { key: 'pflege', label: 'Pflegeheime', color: '#db2777', Icon: HeartPulse, iconNode: heartPulseNode },
  { key: 'schule', label: 'Schulen / Kitas', color: '#ca8a04', Icon: School, iconNode: schoolNode },
  { key: 'apotheke', label: 'Apotheken', color: '#059669', Icon: Pill, iconNode: pillNode },
  { key: 'tankstelle', label: 'Tankstellen', color: '#475569', Icon: Fuel, iconNode: fuelNode },
  { key: 'gastronomie', label: 'Gastronomie', color: '#ea580c', Icon: Utensils, iconNode: utensilsNode },
  { key: 'hotel', label: 'Hotels / Unterkünfte', color: '#0891b2', Icon: Hotel, iconNode: hotelNode },
];

export const POI_BY_KEY = Object.fromEntries(POI_CATEGORIES.map(c => [c.key, c]));

export const POI_MIN_ZOOM = 14;

// Lucide-Icon als SVG-Text (feste Pfaddaten aus der Bibliothek, keine Nutzereingaben)
export const iconSvg = (iconNode, size) => {
  const children = iconNode.map(([tag, attrs]) => {
    const attributes = Object.entries(attrs)
      .filter(([name]) => name !== 'key')
      .map(([name, value]) => `${name}="${value}"`)
      .join(' ');
    return `<${tag} ${attributes}/>`;
  }).join('');
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round">${children}</svg>`;
};
